/* ============================================================
   STORAGE MANAGER - PRODUCTION CLASS
   ============================================================
   Version: 2.0.0
   ============================================================ */

class StorageManager {
  constructor() {
    this.keys = {
      cityId: 'city_id',
      cityName: 'city_name',
      cityData: 'city_data',
      apiId: 'id'
    };
    
    this.listeners = [];
    this.init();
  }

  init() {
    window.addEventListener('storage', (e) => {
      if (e.key === this.keys.cityId || e.key === this.keys.cityName) {
        console.log('📌 Storage changed:', e.key, e.newValue);
        this.notifyListeners();
      }
    });
  }

  getCityId() {
    return localStorage.getItem(this.keys.cityId) || 
           sessionStorage.getItem(this.keys.apiId) || 
           sessionStorage.getItem(this.keys.cityId);
  }

  getCityName() {
    return localStorage.getItem(this.keys.cityName) || 
           sessionStorage.getItem(this.keys.cityName);
  }

  getCityData() {
    const data = localStorage.getItem(this.keys.cityData);
    try {
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  }

  saveCityData(cityId, cityName, fullData = null) {
    localStorage.setItem(this.keys.cityId, String(cityId));
    if (cityName) {
      localStorage.setItem(this.keys.cityName, cityName);
    }
    if (fullData) {
      localStorage.setItem(this.keys.cityData, JSON.stringify(fullData));
    }
    
    sessionStorage.setItem(this.keys.apiId, String(cityId));
    sessionStorage.setItem(this.keys.cityId, String(cityId));
    if (cityName) {
      sessionStorage.setItem(this.keys.cityName, cityName);
    }
    
    console.log('💾 City data saved:', { cityId, cityName });
    
    // 🔥 Trigger custom event for banner reload
    const event = new CustomEvent('cityUpdated', {
      detail: {
        cityId: cityId,
        cityName: cityName,
        fullData: fullData
      }
    });
    document.dispatchEvent(event);
    
    this.notifyListeners();
  }

  clearCityData() {
    localStorage.removeItem(this.keys.cityId);
    localStorage.removeItem(this.keys.cityName);
    localStorage.removeItem(this.keys.cityData);
    sessionStorage.removeItem(this.keys.apiId);
    sessionStorage.removeItem(this.keys.cityId);
    sessionStorage.removeItem(this.keys.cityName);
    this.notifyListeners();
  }

  addListener(callback) {
    this.listeners.push(callback);
  }

  notifyListeners() {
    const data = {
      cityId: this.getCityId(),
      cityName: this.getCityName(),
      cityData: this.getCityData()
    };
    this.listeners.forEach(callback => callback(data));
  }

  hasCityData() {
    return !!this.getCityId();
  }
}

// Singleton instance
window.storageManager = new StorageManager();